module.exports = __webpack_public_path__ + "static/media/2-en.cc6e7304.svg";